import {
  CursorPaginationSchema,
  adminApi,
  apiEndpoint,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { MediaAsset } from "@apis/media/models";

export const playgroundApi = adminApi(
  { domain: API_DOMAIN, path: "playground" },
  {
    createMediaUploadUrl: apiEndpoint({
      body: MediaAsset.createSchema.omit({
        metadata: true,
        metadataPrincipalId: true,
        principalId: true,
      }),
      response: z.object(
        { mediaAsset: MediaAsset.schema, uploadUrl: z.url() },
        {
          mediaAsset: "The media asset created for the upload",
          uploadUrl: "The presigned URL to PUT the file's bytes to",
        },
      ),
    }),
    finalizeMediaUpload: apiEndpoint({
      body: z.object(
        { id: MediaAsset.shape.id },
        { id: MediaAsset.descriptions.id },
      ),
      response: z.object(
        { mediaAsset: MediaAsset.schema },
        { mediaAsset: "The media asset, marked uploaded" },
      ),
    }),
    getMediaPreviews: apiEndpoint({
      body: CursorPaginationSchema,
      response: cursorPaginatedResponse(
        z.object(
          { mediaAsset: MediaAsset.schema, previewUrl: z.url() },
          {
            mediaAsset: "The media asset",
            previewUrl: "The URL of the asset's preview, or of its original",
          },
        ),
      ),
    }),
  },
);
